import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const NOT_PROVIDED_LABEL = 'Non renseigné';

const fieldStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
`;

const fieldLabelStyle = css`
	${theme.typography.eyebrow}
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

const fieldValueStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

const fieldValueMissingStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkFaint};
`;

type Props = {
	readonly label: string;
	readonly value: string | null;
};

/** Renders the field's value, or the `inkFaint` "Non renseigné" placeholder when the API sent `null`. */
const FieldRow: React.FC<Props> = ({ label, value }) => {
	return (
		<div css={fieldStyle}>
			<span css={fieldLabelStyle}>{label}</span>
			<p css={value !== null ? fieldValueStyle : fieldValueMissingStyle}>
				{value ?? NOT_PROVIDED_LABEL}
			</p>
		</div>
	);
};

export default FieldRow;
